(() => {
  const section = document.querySelector('[data-hx-warranty]');
  if (!section) return;

  const reveal = () => section.classList.add('is-inview');

  if (!('IntersectionObserver' in window)) {
    reveal();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        reveal();
        io.disconnect(); // run once
      }
    });
  }, { threshold: 0.2 });

  io.observe(section);
})();
